export const MainLoader = `
<div class="loader-container">
<div class="loader-content">
<p class="name">Ajmal Moha'd</p>
<div class="data" data-progress="0"></div>
<p class="title">Web Developer</p>
</div>
</div>
`;
